var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#1480FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81641 15.1813L15.1804 8.81738",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5909 16.7731L10.9392 19.4248C10.0953 20.2685 8.95077 20.7424 7.75743 20.7423C6.56409 20.7422 5.41965 20.2681 4.57583 19.4242C3.73201 18.5804 3.25791 17.436 3.25781 16.2426C3.25771 15.0493 3.73161 13.9048 4.57529 13.0608L7.22694 10.4092",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7741 13.5909L19.4258 10.9392C20.2694 10.0953 20.7433 8.95077 20.7432 7.75743C20.7431 6.56409 20.269 5.41965 19.4252 4.57583C18.5814 3.73201 17.437 3.25791 16.2436 3.25781C15.0503 3.25771 13.9058 3.73161 13.0618 4.57529L10.4102 7.22694",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.a80bcaba949ae94ebc2029b00d6f5233.svg";
export { ForwardRef as ReactComponent };